import { createContext } from "react";
import { UserContextInfo } from "../../utils/types";

export const UserContext = createContext<UserContextInfo>({} as UserContextInfo);
